import { DNA_COMPLEMENT } from "@/lib/science/iupac";
import { cleanSequence } from "@/lib/science/sequence";

export type SeqOp = "reverse-complement" | "complement" | "reverse";

export interface RevCompResult {
  /** cleaned input (uppercased, non-letters stripped) */
  input: string;
  output: string;
  /** residues that had no known complement (kept as-is) */
  invalid: string[];
}

/**
 * Reverse-complement (or just complement / reverse) a nucleotide sequence.
 * IUPAC ambiguity codes are complemented correctly. When `rna` is true the
 * output uses U in place of T.
 */
export function transformSequence(
  input: string,
  op: SeqOp,
  rna = false,
): RevCompResult {
  const seq = cleanSequence(input);
  const invalid = new Set<string>();

  const complemented =
    op === "reverse"
      ? seq
      : [...seq]
          .map((ch) => {
            const c = DNA_COMPLEMENT[ch];
            if (c === undefined) {
              invalid.add(ch);
              return ch;
            }
            return c;
          })
          .join("");

  let output =
    op === "complement" ? complemented : [...complemented].reverse().join("");
  if (rna) output = output.replace(/T/g, "U");

  return { input: seq, output, invalid: [...invalid] };
}
